import React, { useState } from "react";
import {
  card,
  cardInner,
  cardTitle,
  cardTitleWrap,
  comingSoonTitle,
  cardsWrap,
  cardsWrapGrid,
} from "../styles/DashboardStyles";
import { fetchApps } from 'scripts/fetchApps'
import { useNavigate } from "react-router-dom";
import CardsCarousel from "components/CardsCarousel";
import App from "interfaces/App.interface";

const DashboardTiles: React.FC<{ user?: string }> = ({ user }) => {
  const [apps, setApps] = useState<App[] | undefined>([]);
  const [background, setBackground] = useState<string | undefined>(undefined);
  const navigate = useNavigate();

  React.useEffect(() => {
    const fetchData = async () => {
      const appsResponse = await fetchApps();
      setApps(appsResponse?.filter((item: App) => !item?.name?.toLowerCase().includes('background')));
      setBackground(appsResponse?.filter((item: App) => item?.name?.toLowerCase().includes('background'))[0]?.image);
    };
    fetchData();
  }, []);

  if (!apps) return null;

  const activeApps = apps.filter(app => app.isActive !== false);
  const comingSoonApps = apps.filter(app => app.isActive === false);

  return (
    <>
      <CardsCarousel
        apps={activeApps}
        user={user || ""}
        card={card}
        cardInner={cardInner}
        cardTitleWrap={cardTitleWrap}
        cardTitle={cardTitle}
        navigate={navigate}
        containerStyle={comingSoonApps && comingSoonApps.length > 0 ?
          ({...cardsWrap, background: `url(${background}) center/cover`}) :
          ({...cardsWrapGrid, background: `url(${background}) center/cover`})}
      />
      {comingSoonApps && comingSoonApps.length > 0 && (
        <>
          <div style={comingSoonTitle}>Coming Soon</div>
          <CardsCarousel
            apps={comingSoonApps}
            user={user || ""}
            card={card}
            cardInner={cardInner}
            cardTitleWrap={cardTitleWrap}
            cardTitle={cardTitle}
            navigate={navigate}
            containerStyle={{ ...cardsWrap, background: 'none', position: 'relative' }}
          />
        </>
      )}
    </>
  );
};

export default DashboardTiles;
